export default __webpack_public_path__ + "static/media/page11.e1decb5e.webp";